"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const _666Icon = createIcon({
  displayName: "_666Icon",
  viewBox: "0 0 500 500",
  path: (
    <>
      <path
        d="m21.848703 18.528433h55.984989v55.983826h-55.984989z"
        fill="currentColor"
      />
      <path
        d="m101.69347 18.528433h55.983826v55.984989h-55.983826z"
        fill="currentColor"
      />
      <path
        d="m21.848703 99.87114h55.984989v55.982662h-55.984989z"
        fill="currentColor"
      />
      <path
        d="m101.69347 99.869972h55.983826v55.983826h-55.983826z"
        fill="currentColor"
      />
      <path
        d="m182.44797 18.773035h55.982662v55.984989h-55.982662z"
        fill="currentColor"
      />
      <path
        d="m262.2869 18.773035h55.98732v55.984989h-55.98732z"
        fill="currentColor"
      />
      <path
        d="m182.44797 100.11575h55.982662v55.982662h-55.982662z"
        fill="currentColor"
      />
      <path
        d="m262.2869 100.11575h55.98732v55.983826h-55.98732z"
        fill="currentColor"
      />
      <path
        d="m21.848703 181.45615h55.984989v55.986153h-55.984989z"
        fill="currentColor"
      />
      <path
        d="m101.69347 181.45615h55.983826v55.986153h-55.983826z"
        fill="currentColor"
      />
      <path
        d="m21.848703 262.79886h55.984989v55.983826h-55.984989z"
        fill="currentColor"
      />
      <path
        d="m101.69347 262.80118h55.983826v55.982662h-55.983826z"
        fill="currentColor"
      />
      <path
        d="m182.44797 181.45615h55.982662v55.984989h-55.982662z"
        fill="currentColor"
      />
      <path
        d="m262.2869 181.45497h55.98732v55.98732h-55.98732z"
        fill="currentColor"
      />
      <path
        d="m182.44797 262.7977h55.982662v55.984989h-55.982662z"
        fill="currentColor"
      />
      <path
        d="m262.2869 262.80005h55.98732v55.982662h-55.98732z"
        fill="currentColor"
      />
      <path
        d="m341.47586 18.774208h55.984989v55.984989h-55.984989z"
        fill="currentColor"
      />
      <path
        d="m341.47586 100.11692h55.984989v55.983826h-55.984989z"
        fill="currentColor"
      />
      <path
        d="m341.47586 181.45615h55.984989v55.986153h-55.984989z"
        fill="currentColor"
      />
      <path
        d="m341.47586 262.80118h55.984989v55.982662h-55.984989z"
        fill="currentColor"
      />
      <path
        d="m21.979166 344.14273h55.983826v55.983826h-55.983826z"
        fill="currentColor"
      />
      <path
        d="m101.82161 344.14273h55.983826v55.983826h-55.983826z"
        fill="currentColor"
      />
      <path
        d="m182.57726 344.14273h55.983826v55.983826h-55.983826z"
        fill="currentColor"
      />
      <path
        d="m262.4162 344.14154h55.98732v55.983826h-55.98732z"
        fill="currentColor"
      />
      <path
        d="m341.604 344.14273h55.98732v55.983826h-55.98732z"
        fill="currentColor"
      />
      <path
        d="m421.44528 18.773035h55.98732v55.983826h-55.98732z"
        fill="currentColor"
      />
      <path
        d="m422.16397 100.11457h55.98732v55.983826h-55.98732z"
        fill="currentColor"
      />
      <path
        d="m422.16397 181.45615h55.98732v55.986153h-55.98732z"
        fill="currentColor"
      />
      <path
        d="m422.16397 262.79886h55.98732v55.982662h-55.98732z"
        fill="currentColor"
      />
      <path
        d="m421.57462 344.14044h55.98732v55.983826h-55.98732z"
        fill="currentColor"
      />
      <path
        d="m22.56855 425.48773h55.983826v55.983826h-55.983826z"
        fill="currentColor"
      />
      <path
        d="m102.41098 425.49008h55.984989v55.981499h-55.984989z"
        fill="currentColor"
      />
      <path
        d="m182.51202 425.48773h55.983826v55.983826h-55.983826z"
        fill="currentColor"
      />
      <path
        d="m262.35214 425.49008h55.98732v55.981499h-55.98732z"
        fill="currentColor"
      />
      <path
        d="m342.19455 425.49008h55.984989v55.981499h-55.984989z"
        fill="currentColor"
      />
      <path
        d="m422.16397 425.48773h55.98732v55.983826h-55.98732z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default _666Icon;
